import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class PlayerService {
  static async update(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PLAYER_UPDATE(
          $id: String!
          $data: PlayerInput!
          $manage: ManageInput!
        ) {
          playerUpdate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.playerUpdate;
  }
  
  static async updateTeams(id, subpropertyId, teams) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PLAYER_UPDATE(
          $id: String!
          $subpropertyId: String!
          $teams: [TeamInput]!
        ) {
          playerUpdateTeams(id: $id, subpropertyId: $subpropertyId, teams: $teams)
        }
      `,

      variables: {
        id,
        subpropertyId,
        teams,
      },
    });

    return response.data.playerUpdateTeams;
  }

  static async destroyAll(ids, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PLAYER_DESTROY($ids: [String!]! $manage: ManageInput!) {
          playerDestroy(ids: $ids, manage: $manage)
        }
      `,

      variables: {
        ids,
        manage,
      },
    });

    return response.data.playerDestroy;
  }

  static async create(id, data, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PLAYER_CREATE($id: String! $data: PlayerInput! $manage: ManageInput!) {
          playerCreate(id: $id, data: $data, manage: $manage) {
            id
          }
        }
      `,

      variables: {
        id,
        data,
        manage,
      },
    });

    return response.data.playerCreate;
  }

  static async import(values, importHash, manage) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation PLAYER_IMPORT(
          $data: PlayerInput!
          $importHash: String!
          $manage: ManageInput!
        ) {
          playerImport(data: $data, importHash: $importHash, manage: $manage)
        }
      `,

      variables: {
        data: values,
        importHash,
        manage,
      },
    });

    return response.data.playerImport;
  }

  static async find(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PLAYER_FIND($id: String! $manage: ManageInput!) {
          playerFind(id: $id, manage: $manage) {
            id
            teams {
              id
              name
              programs
              logo {
                id
                publicUrl
              }
            }
            firstName
            lastName
            birthdate {
              day
              month
              year
            }
            picture {
              id
              name
              type
              sizeInBytes
              publicUrl
              privateUrl
            }
            isMember
            careerInfo
            programs
            country
            gender
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.playerFind;
  }

  static async inscriptions(id, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PLAYER_INSCRIPTIONS($id: String! $manage: ManageInput!) {
          inscriptions(id: $id, manage: $manage) {
            id
            status
            program {
              name
            }
            subprogram {
              name
            }
            status
          }
        }
      `,

      variables: {
        id,
        manage,
      },
    });

    return response.data.inscriptions;
  }

  static async getTeams(id, subpropertyId) {
    const response = await graphqlClient.query({
      query: gql`
        query PLAYER_GET_TEAMS($id: String!, $subpropertyId: String!) {
          playerGetTeams(id: $id, subpropertyId: $subpropertyId) {
            id
            name
            program {
              id
              name
              type
            }
            subprogram {
              id
              name
            }
          }
        }
      `,

      variables: {
        id,
        subpropertyId,
      },
    });

    return response.data.playerGetTeams;
  }

  static async newId(manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PLAYER_NEW_ID ($manage: ManageInput!){
          playerNewId(manage: $manage)
        }
      `,
      variables: {
        manage,
      },
    });
    return response.data.playerNewId;
  }

  static async list(filter, orderBy, limit, offset, manage) {
    if ( !manage.subpropertyId ) return { rows: [], count: 0};
    const response = await graphqlClient.query({
      query: gql`
        query PLAYER_LIST(
          $filter: PlayerFilterInput
          $orderBy: PlayerOrderByEnum
          $limit: Int
          $offset: Int
          $manage: ManageInput!
        ) {
          playerList(
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
            manage: $manage
          ) {
            count
            rows {
              id
              firstName
              lastName
              birthdate {
                day
                month
                year
              }
              picture {
                id
                name
                type
                sizeInBytes
                publicUrl
                privateUrl
              }
              teams {
                id
                name
              }
              programs
              gender
              family
              lastLogin
              updatedAt
              createdAt
            }
          }
        }
      `,

      variables: {
        filter,
        orderBy,
        limit,
        offset,
        manage,
      },
    });
    
    return response.data.playerList;
  }

  static async listAutocomplete(query, limit, manage) {
    const response = await graphqlClient.query({
      query: gql`
        query PLAYER_AUTOCOMPLETE(
          $query: String
          $limit: Int
          $manage: ManageInput!
        ) {
          playerAutocomplete(query: $query, limit: $limit, manage: $manage) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
        manage,
      },
    });

    return response.data.playerAutocomplete;
  }
}
